import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-4xl mt-32 lg:mt-28" }
const _hoisted_2 = {
  key: 0,
  class: "pt-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm p-6 mt-32 lg:mt-28" }, "do you remember the meaning?", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("show answer")
const _hoisted_5 = {
  key: 1,
  class: "mt-2 rounded"
}
const _hoisted_6 = {
  controls: "",
  class: "w-full rounded",
  autoplay: ""
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]

import { CardData } from "@/CardData";
import MyButton from "./MyButton.vue";
import MyCard from "./MyCard.vue";

import { computed } from "vue";
import { isPremium } from "@/User";
import { store } from "@/store";

export default /*#__PURE__*/_defineComponent({
  props: {
  card: CardData,
},
  setup(__props) {

const props = __props


const audioUrl = computed(() => props?.card?.audio?.url);
const user = computed(() => store.state.user);
const playAudio = computed(() => {
  if (!user.value) throw new Error("user is not available");
  return isPremium(user.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MyCard, null, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.card?.front), 1),
      (__props.card?.romanization)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.card?.romanization), 1))
        : _createCommentVNode("", true),
      _hoisted_3,
      _createVNode(MyButton, {
        onClickButton: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('flip')))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      (_unref(playAudio) && _unref(audioUrl))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("audio", _hoisted_6, [
              _createElementVNode("source", {
                src: _unref(audioUrl),
                type: "audio/mp3"
              }, null, 8, _hoisted_7)
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.card?.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: __props.card?.image.url,
            class: "hidden"
          }, null, 8, _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})